import { render } from "./StudyFieldPortal.vue?vue&type=template&id=3090e42e&scoped=true"
import script from "./StudyFieldPortal.vue?vue&type=script&lang=js"
export * from "./StudyFieldPortal.vue?vue&type=script&lang=js"

import "./StudyFieldPortal.vue?vue&type=style&index=0&id=3090e42e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3090e42e"]])

export default __exports__